import { UseQueryResult } from '@tanstack/react-query'
import { Button, Flex, Form, Modal, ModalProps } from 'antd'

import { useTreatmentServiceGetListPregnancyMonitoringInvestigationsEndpoint } from 'src/api/queries'
import {
  GetPatientPregnancyMonitoringResponse,
  GetPregnancyMonitoringResponse
} from 'src/api/requests'
import { PregnancyInvestigationsCard, Text } from 'src/components'
import { ConsultationPregnancyCard } from 'src/features/persons/components'
import { useLocales } from 'src/locales'

type Props = {
  id?: string
  useQueryFn: (args: {
    id: string
  }) => UseQueryResult<
    GetPatientPregnancyMonitoringResponse | GetPregnancyMonitoringResponse
  >
  onCancel: () => void
} & ModalProps

export const PersonPregnancyDetailsModal = ({
  id,
  useQueryFn,
  onCancel
}: Props) => {
  const { t } = useLocales()

  const [form] = Form.useForm()

  const { data } = useQueryFn({
    id: String(id)
  })

  const { data: investigations } =
    useTreatmentServiceGetListPregnancyMonitoringInvestigationsEndpoint({
      pageNumber: 1,
      ids: [String(id)]
    })

  return (
    <Modal
      open
      onCancel={onCancel}
      maskClosable={false}
      width={920}
      footer={[
        <Flex key="back" justify="center">
          <Button onClick={onCancel} type="primary">
            {t('investigations.close')}
          </Button>
        </Flex>
      ]}
      title={
        <Text weight={700} size="xxl">
          {t('common.details')}
        </Text>
      }
    >
      <Flex vertical gap={16}>
        <Form form={form} layout="vertical" requiredMark={false} disabled>
          <ConsultationPregnancyCard isOnDetailsModal data={data} form={form} />
        </Form>
        {id && (
          <PregnancyInvestigationsCard
            id={id}
            investigations={investigations}
          />
        )}
      </Flex>
    </Modal>
  )
}
